type TStreamChatSseOptions<TEvent> = {
  url: string;
  body: unknown;
  signal?: AbortSignal;
  onEvent: (event: TEvent) => void;
  onParseError?: (error: unknown, rawLine: string) => void;
};

export async function streamChatSse<TEvent>({
  url,
  body,
  signal,
  onEvent,
  onParseError
}: TStreamChatSseOptions<TEvent>): Promise<void> {
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
    signal
  });

  if (!response.ok || !response.body) {
    throw new Error(`Chat request failed with status ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  const handleLine = (line: string) => {
    const trimmed = line.trim();
    if (!trimmed.startsWith("data: ")) return;
    const jsonStr = trimmed.slice(6);
    if (!jsonStr) return;

    try {
      onEvent(JSON.parse(jsonStr) as TEvent);
    } catch (error) {
      onParseError?.(error, jsonStr);
    }
  };

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";
    lines.forEach(handleLine);
  }

  // A final data: line without a trailing newline would otherwise be dropped.
  buffer += decoder.decode();
  if (buffer) handleLine(buffer);
}
